// third-party
import { createSlice } from '@reduxjs/toolkit';

// project import
import VenueTypeDto from 'common/dto-types/venue-type-dto';
import { SortingParam, SortingType } from 'components/base-table/dto';
import { DefaultVisibleVenueTypeColumns } from 'pages/venue-type-list-page/venue-type-column-config';
import { Filters } from 'react-table';

type VenueTypeSliceStates = {
    data?: VenueTypeDto;
    isFormOpen: boolean;
    filters: Filters<any>;
    sorting: SortingParam;
    visibleColumns: Array<string>;
};

const initialState: VenueTypeSliceStates = {
    isFormOpen: false,
    filters: [],
    sorting: { sortingType: SortingType.Ascending, sortBy: 'name', searchTerm: '' },
    visibleColumns: DefaultVisibleVenueTypeColumns,
};

const venueType = createSlice({
    name: 'venueType',
    initialState,
    reducers: {
        openCreateForm(state) {
            state.isFormOpen = true;
        },

        closeForm(state) {
            state.data = undefined;
            state.isFormOpen = false;
        },

        setVenueType(state, action) {
            state.data = action.payload;
        },

        setVenueTypeListPersistence(state, action) {
            state.filters = action.payload.filters;
            state.sorting = action.payload.sorting;
        },

        setVenueTypeColumnsPersistence(state, action) {
            state.visibleColumns = action.payload;
        },
    },
});

export default venueType.reducer;

export const { openCreateForm, closeForm, setVenueType, setVenueTypeListPersistence, setVenueTypeColumnsPersistence } =
    venueType.actions;
